export const isStage = () => {
  return process.env.NEXT_PUBLIC_STAGE === 'STG';
};
